import * as React from 'react';
import { styled } from '@mui/material/styles';
import { default as MuiRadio } from '@mui/material/Radio';
import "./input-radio.styles.css";

const TtmIcon = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: 16,
  height: 16,
  boxShadow:'0 0 0 1px rgb(55 55 55 / 15%)',
  backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:'rgba(206,217,224,.5)',
  },
}));

const TtmCheckedIcon = styled(TtmIcon)({
  backgroundColor: 'var(--color-primary)',
  '&:before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
    content: '""',
  },
});

const TtmIconSub = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: 12,
  height: 12,
  boxShadow:'0 0 0 1px rgb(55 55 55 / 15%)',
  backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:'rgba(206,217,224,.5)',
  },
}));

const TtmCheckedIconSub = styled(TtmIconSub)({
  backgroundColor: 'var(--color-primary)',
  '&:before': {
    display: 'block',
    width: 12,
    height: 12,
    backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
    content: '""',
  },
});

// Inspired by blueprintjs
function Radio(props) {
  return (
    <MuiRadio
      sx={{
        '&:hover': {
          bgcolor: 'transparent',
        },
        '& .MuiFormControlLabel-label': {
          fontFamily: 'var(--font-primary), sans-serif'
        }
      }}
      disableRipple
      checkedIcon={<TtmCheckedIcon />}
      icon={<TtmIcon />}
      {...props}
    />
  );
}

function RadioSub(props) {
  return (
    <MuiRadio
      sx={{
        '&:hover': {
          bgcolor: 'transparent',
        },
        '& .MuiFormControlLabel-label': {
          fontFamily: 'var(--font-primary), sans-serif'
        }
      }}
      disableRipple
      checkedIcon={<TtmCheckedIconSub />}
      icon={<TtmIconSub />}
      {...props}
    />
  );
}

export default function InputRadio(props) {
  const {name, ...others} = props;
  if(props.sub){
    return (
      <div className="input-radio-container">
        <RadioSub name={name? name:"radio"} {...others} className="radio-sub" />
      </div>
   );
  }else {
    return (
      <div className="input-radio-container">
        <Radio name={name? name:"radio"} {...others}/>
      </div>
   );
  }
}